<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav mb-1">
        <h3>Overzicht verwezelijkte recup {{ this.currentlySelectedMonth | toYear }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <th>Maand</th>
            <th>Gepresteerde uren</th>
            <th>Vereiste uren</th>
            <th>Verschil</th>
            <th>Opgebouwde recup</th>
          </tr>
          </thead>
          <template v-for="(recupForMonthDto, index) in recupForYearDto">
            <tr :key='index'>
              <td>{{ recupForMonthDto.yearMonth }}</td>
              <td>{{ recupForMonthDto.workedHours }}</td>
              <td>{{ recupForMonthDto.neededHours }}</td>
              <td>{{ recupForMonthDto.differenceHours }}</td>
              <td>{{ recupForMonthDto.cumulativeHours }}</td>
            </tr>
          </template>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <th>Datum</th>
            <th>Uren</th>
            <th>Reden</th>
          </tr>
          </thead>
          <template v-for="(recupBonus, index) in recupBonuses">
            <tr :key='index'>
              <td>{{ recupBonus.date }}</td>
              <td>{{ recupBonus.hours }}</td>
              <td>{{ recupBonus.reason }}</td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
  name: "UserViewRecup",
  computed: {
    ...mapGetters({
      currentlySelectedMonth: "time/currentlySelectedMonth",
      recupForYearDto: "timesheet/recupForYearDto",
      recupBonuses: "timesheet/recupBonuses"
    }),
  },
  async created() {
    await this.fetchRecupForYear();
  },

  methods: {
    ...mapActions("timesheet", ["fetchRecupForYear"]),
  },
};


</script>

<style scoped>

</style>
